<template>
  <div class="bg">
    <div class="main d-flex align-items-center">
      <div class="login-form mx-auto" style="width: 76%;">
        <form class="form-custom mx-auto" style="width: 80%;">
          <div class="closeIcon" @click="closeDetail">
            <img src="../assets/images/btn_close.png" alt="">
          </div>
          <div class="wrapper">
            <div class="scrollbar" id="style-3">
              <div class="force-overflow">
                <div class="mx-auto" style="width:60%">
                  <!-- <img width="50%" src="../assets/exam/L001_unlock_b.jpg" alt=""> -->
                  <div class="textBox">
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit. Doloribus vel quasi dolorum repellendus, quaerat repellat ad accusamus numquam quo laboriosam sunt id natus optio iste maiores a ratione, tempore totam?
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'DetailPage',

  data () {
    return {
      account: '',
      password: '',
      close: false
    }
  },
  methods: {
    closeDetail () {
      this.$emit('closeDetail', this.close)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .bg {
    height: calc(100vh - 100px);
    width: 100%;
    height: 100%;
    background:rgba(0,0,0,0.9);
    position: fixed;
    z-index: 50;
    top: 0;
    left: 0;
    .closeIcon {
      cursor: pointer;
    }
  }
  @media screen and (max-width: 1000px) {
    .main {
      height: calc(100vh + 178px);
      position: relative;
    }
    img {
      top: 33% !important;
    }
  }
  .closeIcon {
    margin-bottom: 30px;
    img {
      position: absolute;
      top: 20%;
      right: 20%;
      margin-left: 50px;
    }
  }
  .textBox {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .wrapper {
    margin-top: 200px;
		text-align: left;
    color: #ffffff;
		padding: 5px;
		border-radius: 10px;
		padding: 10px 20px;
    img {
      margin: 0 25%;
    }
	}
  .scrollbar {
		height: 300px;
		width: 100%;
		overflow-y: auto;
	}
	#style-3::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
		background-color: #F5F5F5;
	}
	#style-3::-webkit-scrollbar {
		width: 2px;
		background-color: #F5F5F5;
	}
	#style-3::-webkit-scrollbar-thumb {
		background-color: #e20c0c;
	}
</style>
